import { useMutation } from '@apollo/client/react';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import { ModalTypography } from 'components/styles_components/typography';
import EditMutation from 'mutations/inspection_result/edit';
import Form from 'components/inspection_result/modal/edit/edit_form';

const Edit = ({ inspectionResult, handleClose, onSuccess }) => {
  const setError = useError();
  const [editInspectionResult, { loading }] = useMutation(EditMutation, {
    onCompleted: onSuccess,
    onError: () => {
      setError('error.inspection_result.edit');
    },
  });

  const submit = (values) => {
    editInspectionResult({
      variables: {
        id: inspectionResult.id,
        doneAt: values.doneAt,
        result: values.result,
        notes: values.notes || null,
        inspectionFields: values.inspectionFields.map((field) => ({
          id: field.id,
          value: field.value ?? false,
        })),
      },
    });
  };

  const fields = [...(inspectionResult.inspectionResultFields ?? [])].sort(
    (a, b) => (a.order ?? 0) - (b.order ?? 0)
  );

  return (
    <>
      <ModalTypography variant="h5" align="center">
        <FormattedMessage id="header.inspection_result.edit" />
      </ModalTypography>
      <Form
        initialValues={{
          doneAt: inspectionResult.doneAt ? new Date(inspectionResult.doneAt) : null,
          result: inspectionResult.result ?? '',
          notes: inspectionResult.notes ?? '',
          inspectionFields: fields.map((field) => ({
            id: field.id,
            inspectionFieldId: field.inspectionFieldId,
            name: field.name,
            value: field.value ?? false,
          })),
        }}
        processing={loading}
        onSubmit={submit}
        onCancel={handleClose}
      />
    </>
  );
};

export default Edit;
